module.exports = __webpack_public_path__ + "static/img/flexiquote-logo-tagline-white.4549f754.svg";